
/*
We have 2 login options:
- Regular login flow (/login page)
- Modal iframe login (it opens a modal with an iframe pointing to /login/iframe)

The login iframe is loaded after everything else has been loaded.

If the user clicks on something that requires authentication before the iframe has been loaded,
then they will be redirected to the regular login flow. This is to prevent a problem with the iframe
interfering with the login flow.
 */
Modules.Shared.Helpers.JsonResponseHandler = {
  getCurrentUrl: function() {
    return window.location.protocol + "//" + window.location.host + window.location.pathname;
  },
  redirectToLogin: function() {
    var currentUrl, loginLink;
    OptimizeSuite.TrackingHub.add('Coupons-Login-Redirect');
    currentUrl = this.getCurrentUrl();
    loginLink = "/login?ref=" + currentUrl + "&return_to=" + currentUrl;
    return window.location.href = loginLink;
  },
  openModalIframeLogin: function() {
    OptimizeSuite.TrackingHub.add('Coupons-Login-Modal');
    return IframeLogin.openModal(this.getCurrentUrl());
  },
  loginRequired: function(res, options) {
    var ref;
    if (options == null) {
      options = {};
    }
    if ((res != null ? (ref = res.error) != null ? ref.code : void 0 : void 0) !== 'login-required') {
      return false;
    }
    if (options.method === 'redirect' || !$('#login-modal').length) {
      this.redirectToLogin();
    } else {
      this.openModalIframeLogin();
    }
    return true;
  }
};

module.exports = Modules.Shared.Helpers.JsonResponseHandler;

